/** Provides the surface identity for everything rendered inside one pane. */
import React from 'react';

import { SurfaceContext } from './surfaceContext';

interface Props {
  /** The workspace tab id this pane is showing. */
  surfaceId: string;
  children: React.ReactNode;
}

/** Scope a pane's subtree to its own surface id. */
export const SurfaceProvider: React.FC<Props> = ({ surfaceId, children }) => (
  <SurfaceContext.Provider value={surfaceId}>{children}</SurfaceContext.Provider>
);
